module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "onboarding-tours": "static-1.16867"
    },
    "depPathPrefixes": {
      "onboarding-tours": "/onboarding-tours/static-1.16867"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.38784",
    "project": "onboarding-tours",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};